import {SubscriptionOffer} from './subscription-offer.entity';


export class Statistic {
  count: number;

  retailer_id: number;

  type: string;

  status_id: number;

  date: string;
  default: number;
  pet: number;
  pet2: number;
  cat: number;
  cat2: number;
  silver: number;
  sport: number;
  pdfou: number;
  skiset: number;
  total: number;

  subscription_type: string;
  option_type: string;
  value_int: number;

  tracker_type: string;

  sms: number;
  guarantee: number;
}


export class DateCountStatistic {
  count: number;

  date: string;
}


export class TrackerTypeCountStatistic {
  total: number;

  tracker_type: string;
}


export class SponsoringStatistic {
  nb_with_promo_code_per_tracker: TrackerTypeCountStatistic[];

  nb_with_promo_code: number;

  nb_without_promo_code: number;

  nb_godchild: TrackerTypeCountStatistic[];
}


export class StatisticSubscription {
  date: string[] = [];

  // All active
  all_subscriptions_active: number[] = [];
  all_subscriptions_active_hipay_1: number[] = [];
  all_subscriptions_active_hipay_12: number[] = [];
  all_subscriptions_active_hipay_24: number[] = [];
  all_subscriptions_active_gocardless_1: number[] = [];
  all_subscriptions_active_gocardless_12: number[] = [];
  all_subscriptions_active_gocardless_24: number[] = [];

  // All active renewed
  all_subscriptions_active_hipay_1_renewed: number[] = [];
  all_subscriptions_active_hipay_12_renewed: number[] = [];
  all_subscriptions_active_hipay_24_renewed: number[] = [];
  all_subscriptions_active_gocardless_1_renewed: number[] = [];
  all_subscriptions_active_gocardless_12_renewed: number[] = [];
  all_subscriptions_active_gocardless_24_renewed: number[] = [];

  // All active subscribed
  all_subscriptions_active_hipay_1_subscribed: number[] = [];
  all_subscriptions_active_hipay_12_subscribed: number[] = [];
  all_subscriptions_active_hipay_24_subscribed: number[] = [];
  all_subscriptions_active_gocardless_1_subscribed: number[] = [];
  all_subscriptions_active_gocardless_12_subscribed: number[] = [];
  all_subscriptions_active_gocardless_24_subscribed: number[] = [];

  // All active renewed_next_month
  all_subscriptions_active_hipay_1_renewed_next_month: number[] = [];
  all_subscriptions_active_hipay_12_renewed_next_month: number[] = [];
  all_subscriptions_active_hipay_24_renewed_next_month: number[] = [];
  all_subscriptions_active_gocardless_1_renewed_next_month: number[] = [];
  all_subscriptions_active_gocardless_12_renewed_next_month: number[] = [];
  all_subscriptions_active_gocardless_24_renewed_next_month: number[] = [];

  // All active renewed_next_month_retry
  all_subscriptions_active_hipay_1_renewed_next_month_retry: number[] = [];
  all_subscriptions_active_hipay_12_renewed_next_month_retry: number[] = [];
  all_subscriptions_active_hipay_24_renewed_next_month_retry: number[] = [];
  all_subscriptions_active_gocardless_1_renewed_next_month_retry: number[] = [];
  all_subscriptions_active_gocardless_12_renewed_next_month_retry: number[] = [];
  all_subscriptions_active_gocardless_24_renewed_next_month_retry: number[] = [];

  // All canceled that should have been renewed_next_month
  all_subscriptions_canceled_hipay_1_renewed_next_month: number[] = [];
  all_subscriptions_canceled_hipay_12_renewed_next_month: number[] = [];
  all_subscriptions_canceled_hipay_24_renewed_next_month: number[] = [];
  all_subscriptions_canceled_gocardless_1_renewed_next_month: number[] = [];
  all_subscriptions_canceled_gocardless_12_renewed_next_month: number[] = [];
  all_subscriptions_canceled_gocardless_24_renewed_next_month: number[] = [];

  // All active renewed_successfully
  all_subscriptions_active_hipay_1_renewed_successfully: number[] = [];
  all_subscriptions_active_hipay_12_renewed_successfully: number[] = [];
  all_subscriptions_active_hipay_24_renewed_successfully: number[] = [];
  all_subscriptions_active_gocardless_1_renewed_successfully: number[] = [];
  all_subscriptions_active_gocardless_12_renewed_successfully: number[] = [];
  all_subscriptions_active_gocardless_24_renewed_successfully: number[] = [];

  // All active renewed_successfully retried
  all_subscriptions_active_hipay_1_renewed_successfully_retried: number[] = [];
  all_subscriptions_active_hipay_12_renewed_successfully_retried: number[] = [];
  all_subscriptions_active_hipay_24_renewed_successfully_retried: number[] = [];
  all_subscriptions_active_gocardless_1_renewed_successfully_retried: number[] = [];
  all_subscriptions_active_gocardless_12_renewed_successfully_retried: number[] = [];
  all_subscriptions_active_gocardless_24_renewed_successfully_retried: number[] = [];

  // All active renewed_successfully retried
  all_subscriptions_active_hipay_1_renewed_successfully_not_retried: number[] = [];
  all_subscriptions_active_hipay_12_renewed_successfully_not_retried: number[] = [];
  all_subscriptions_active_hipay_24_renewed_successfully_not_retried: number[] = [];
  all_subscriptions_active_gocardless_1_renewed_successfully_not_retried: number[] = [];
  all_subscriptions_active_gocardless_12_renewed_successfully_not_retried: number[] = [];
  all_subscriptions_active_gocardless_24_renewed_successfully_not_retried: number[] = [];

  // All canceled
  all_subscriptions_canceled: number[] = [];
  all_subscriptions_canceled_hipay_1: number[] = [];
  all_subscriptions_canceled_hipay_12: number[] = [];
  all_subscriptions_canceled_hipay_24: number[] = [];
  all_subscriptions_canceled_gocardless_1: number[] = [];
  all_subscriptions_canceled_gocardless_12: number[] = [];
  all_subscriptions_canceled_gocardless_24: number[] = [];

  // All canceled manually
  all_subscriptions_canceled_byuser: number[] = [];
  all_subscriptions_canceled_byuser_hipay_1: number[] = [];
  all_subscriptions_canceled_byuser_hipay_12: number[] = [];
  all_subscriptions_canceled_byuser_hipay_24: number[] = [];
  all_subscriptions_canceled_byuser_gocardless_1: number[] = [];
  all_subscriptions_canceled_byuser_gocardless_12: number[] = [];
  all_subscriptions_canceled_byuser_gocardless_24: number[] = [];

  all_subscriptions_great_britain: number[] = [];
}

export class StatisticOption {
  date: string[] = [];

  // All Options activated
  all_options_activated: number[] = [];
  all_options_activated_sms: number[] = [];
  all_options_activated_guarantee: number[] = [];
  all_options_activated_having_more_than_1: number[] = [];
}

export class StatisticChurn {
  date: string[] = [];
  all_trackers_0: number[] = [];
  all_trackers_1: number[] = [];
  all_trackers_6: number[] = [];
  all_trackers_21: number[] = [];  // BT
  all_trackers_19: number[] = [];  // MT
  all_trackers_22: number[] = [];  // Ruag
  all_trackers_23: number[] = [];  // Zolux
  all_trackers_1_pet: number[] = [];
  all_trackers_1_pet2: number[] = [];
  all_trackers_1_cat: number[] = [];
  all_trackers_1_cat2: number[] = [];
  all_trackers_1_silver: number[] = [];
  all_trackers_21_default: number[] = [];  // BT
  all_trackers_19_default: number[] = [];  // MT
  all_trackers_22_pet: number[] = [];  // Ruag
  all_trackers_22_pet2: number[] = [];  // Ruag
  all_trackers_23_pet: number[] = [];  // Zolux
  all_trackers_23_pet2: number[] = [];  // Zolux
  all_trackers_23_cat: number[] = [];  // Zolux
  all_trackers_23_cat2: number[] = [];  // Zolux
  all_trackers_0_pet: number[] = [];
  all_trackers_0_pet2: number[] = [];
  all_trackers_0_cat: number[] = [];
  all_trackers_0_cat2: number[] = [];
  all_trackers_0_silver: number[] = [];
  all_trackers_0_default: number[] = [];
  all_trackers_0_sport: number[] = [];
  all_trackers_active_0: number[] = [];
  all_trackers_active_1: number[] = [];
  all_trackers_active_6: number[] = [];
  all_trackers_active_21: number[] = [];  // BT
  all_trackers_active_19: number[] = [];  // MT
  all_trackers_active_22: number[] = [];  // Ruag
  all_trackers_active_23: number[] = [];  // Zolux
  all_trackers_active_22_pet: number[] = [];  // Ruag
  all_trackers_active_22_pet2: number[] = [];  // Ruag
  all_trackers_active_23_pet: number[] = [];  // Zolux
  all_trackers_active_23_pet2: number[] = [];  // Zolux
  all_trackers_active_23_cat: number[] = [];  // Zolux
  all_trackers_active_23_cat2: number[] = [];  // Zolux
  all_trackers_active_1_pet: number[] = [];
  all_trackers_active_1_pet2: number[] = [];
  all_trackers_active_1_cat: number[] = [];
  all_trackers_active_1_cat2: number[] = [];
  all_trackers_active_1_silver: number[] = [];
  all_trackers_active_1_default: number[] = [];
  all_trackers_active_21_default: number[] = [];  // BT
  all_trackers_active_19_default: number[] = [];  // MT
  all_trackers_active_0_pet: number[] = [];
  all_trackers_active_0_pet2: number[] = [];
  all_trackers_active_0_cat: number[] = [];
  all_trackers_active_0_cat2: number[] = [];
  all_trackers_active_0_silver: number[] = [];
  all_trackers_active_0_default: number[] = [];
  all_trackers_active_0_sport: number[] = [];
  all_trackers_inactive_0: number[] = [];
  all_trackers_inactive_1: number[] = [];
  all_trackers_inactive_6: number[] = [];
  all_trackers_inactive_21: number[] = [];  // BT
  all_trackers_inactive_19: number[] = [];  // MT
  all_trackers_inactive_22: number[] = [];  // Ruag
  all_trackers_inactive_23: number[] = [];  // Zolux
  all_trackers_inactive_1_pet: number[] = [];
  all_trackers_inactive_1_pet2: number[] = [];
  all_trackers_inactive_1_cat: number[] = [];
  all_trackers_inactive_1_cat2: number[] = [];
  all_trackers_inactive_1_silver: number[] = [];
  all_trackers_inactive_1_default: number[] = [];
  all_trackers_inactive_21_default: number[] = [];  // BT
  all_trackers_inactive_19_default: number[] = [];  // MT
  all_trackers_inactive_22_pet: number[] = [];  // Ruag
  all_trackers_inactive_22_pet2: number[] = [];  // Ruag
  all_trackers_inactive_23_pet: number[] = [];  // Zolux
  all_trackers_inactive_23_pet2: number[] = [];  // Zolux
  all_trackers_inactive_23_cat: number[] = [];  // Zolux
  all_trackers_inactive_23_cat2: number[] = [];  // Zolux
  all_trackers_inactive_0_pet: number[] = [];
  all_trackers_inactive_0_pet2: number[] = [];
  all_trackers_inactive_0_cat: number[] = [];
  all_trackers_inactive_0_cat2: number[] = [];
  all_trackers_inactive_0_silver: number[] = [];
  all_trackers_inactive_0_default: number[] = [];
  all_trackers_inactive_0_sport: number[] = [];
}

export interface AverageLengthSubscription {
  offer_id: number;

  offer: SubscriptionOffer;

  payment_mean: string;

  average: number;
}

export class MonthlyCohorts {
  payment_mean: string;
  nbr_subscription_1_years: number;
  nbr_subscription_2_years: number;
  nbr_subscription_3_years: number;
  nbr_subscription_4_years: number;
  percentage: number;
}

export class AverageLengthCancelledSubscription {
  all: AverageLengthSubscription[];

  auto: AverageLengthSubscription[];

  manual: AverageLengthSubscription[];

  constructor() {
    this.all = [];
    this.auto = [];
    this.manual = [];
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/statistic.entity.ts